import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  IconButton,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Split from "react-split";
import CloseIcon from "@mui/icons-material/Close";
import CommonGrid from "../../../Repository/CommonGrid";
import { MoreHorizOutlined } from "@mui/icons-material";
import WorkflowSessionModal from "../../WorkflowSessionModal";
import { useSelector } from "react-redux";
import { ParentScreenCtx } from "../../../../pages/workbench_build/WorkbenchBuild";

function CustomWorkflowSessionModal(e) {
  const { value, setValue, data } = e;
  const [workflowSessionModal, setWorkflowSessionModal] = useState({
    open: false,
    isFirstTime: false,
  });

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>{data?.VALUE}</div>
      <Button
        style={{ border: "none", background: "transparent" }}
        onClick={() =>
          setWorkflowSessionModal({ open: true, isFirstTime: true })
        }>
        <MoreHorizOutlined fontSize="small" />
      </Button>
      <WorkflowSessionModal
        valueLabel={data?.NAME || ""}
        showAccountData={true}
        showCallingWorkflow={true}
        showDateAndTime={true}
        showSystemData={true}
        showWorkflowSession={true}
        openModal={workflowSessionModal}
        setModalOpen={setWorkflowSessionModal}
        handleClose={() =>
          setWorkflowSessionModal({ open: false, isFirstTime: false })
        }
        initialValue={value || ""}
        valuesHandler={(value) => {
          // onInputChange("PORT", value);
          setValue(value);
        }}
      />
    </div>
  );
}
function CustomHeaderFieldsModal({
  openModal,
  handleCancelClick,
  handleChange,
}) {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const [rowData, setRowData] = useState([{ id: 0, NAME: "", VALUE: "" }]);
  const [isAddButtonEnabled, setIsAddButtonEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [gridApi, setGridApi] = useState(null);

  const getGridAPI = (api) => {
    setGridApi(api);
  };

  const gridOptions = {
    columnDefs: [
      {
        showDeleteIconOnly: true,
        isDeleteControl: true,
        editable: false,
        suppressMovable: true,
        lockPosition: true,
        showDeleteIcon: (data) => {
          return data.VALUE || data.NAME;
        },
        deleteHandler: (data) => {
          setIsAddButtonEnabled(true);
        },
        headerClass: "first-column-header",
      },
      {
        addNewControl: true,
        addControlLabel: "Add New Key Name",
        headerName: t("COL_KEY_NAME"),
        field: "NAME",
        editable: true,
        showPlaceholder: true,
        placeholder: t("COL_KEY_NAME"),
      },
      {
        headerName: t("COL_KEY_VAL"),
        field: "VALUE",
        editable: true,
        showPlaceholder: true,
        placeholder: t("COL_KEY_VAL"),
        cellRenderer: CustomWorkflowSessionModal,
      },
    ],
  };

  const handleCellValueChanged = (gridOptions) => {
    if (gridOptions.newValue !== gridOptions.oldValue)
      setIsAddButtonEnabled(true);
  };

  const handleAddClick = () => {
    if (!gridApi) return;
    const getRowData = () => {
      const rows = [];
      gridApi?.forEachNode((node) => rows.push(node.data));
      return rows;
    };
    const validRows = getRowData().filter(
      (item) => item.NAME?.trim() || item.VALUE?.trim()
    );

    const arrayToString = (array) =>
      array
        .map(({ NAME, VALUE }) => `${NAME || ""}\u001F${VALUE || ""}`)
        .join("\u001E");

    const headerData = arrayToString(validRows) || null;
    handleChange({ add:{ HTTP_CUSTOM_HEADER_FIELDS: headerData }});
    handleCancelClick();
  };
  
  const onGridReady = (params) => {
    setGridApi(params.api);
      const firstRowNode = params.api.getDisplayedRowAtIndex(0);
      const firstColumn = params.api.getColumnDefs()[1]?.field; 
      
      if (firstRowNode && firstColumn) {
        params.api.startEditingCell({
          rowIndex: firstRowNode.rowIndex, 
          colKey: firstColumn, 
        });
      }
  };
  
  const getRowData = async function () {
    setIsAddButtonEnabled(false);
    setIsLoading(true);
    const fields =
      (await selectedNode?.INBOUND?.HTTP_CUSTOM_HEADER_FIELDS) || "";

    function parseString(input) {
      return input
        ?.split("\u001E")
        .filter(Boolean)
        .map((pair, i) => {
          const [NAME, VALUE] = pair.split("\u001F");
          return { id: i, NAME, VALUE };
        });
    }
    if (fields) {
      const rows = parseString(fields);
      rows.push({ id: rows.length, NAME: "", VALUE: "" });
      setRowData(rows);
    } else {
      setRowData([{ id: 0, NAME: "", VALUE: "" }]);
    }
    setTimeout(() => setIsLoading(false), 1000);
  };

  useEffect(() => {
    if (openModal) getRowData();

    return () => {
      setRowData([{ id: 0, NAME: "", VALUE: "" }]);
    };
  }, [openModal]);

  return (
    <>
      <Drawer
        anchor="left"
        open={openModal}
        sx={{
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: "100%",
            boxShadow: "none",
            backgroundColor: "transparent",
          },
        }}
        onClose={handleCancelClick}>
        <Split
          className="split height-100 flex"
          direction="horizontal"
          gutterSize={4}
          snapOffset={0}
          dragInterval={4}
          minSize={[550, 0]}
          sizes={[67, 33]}>
          <div
            className="flex-column height-100 width-100"
            key="main"
            style={{ backgroundColor: "white", position: "relative" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "1rem",
              }}>
              <div style={{ lineHeight: "25px" }}>
                <p style={{ marginBottom: "10px" }}>
                  {t("LBL_HTTP_CUSTOM_HEADER_FIELDS")}
                </p>
                <p className="font-12">
                  {t("DIAG_MQ_CUSTOM_HEADER_FIELDS_DESC")}
                </p>
              </div>
              <div>
                <IconButton
                  onClick={handleCancelClick}
                  sx={{ borderRadius: "5px" }}>
                  <CloseIcon
                    sx={{
                      height: "28px",
                      width: "28px",
                      color: "#777777",
                    }}
                  />
                </IconButton>
              </div>
            </div>
            <Divider />
            <Box style={{ height: "100%", padding: "12px" }}>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                  }}>
                  {" "}
                  <CircularProgress size={"24px"} />{" "}
                </div>
              ) : (
                <CommonGrid
                  rowData={rowData}
                  gridOptions={gridOptions}
                  getGridAPI={getGridAPI}
                  gridProps={{
                    animateRows: false,
                    ensureDomOrder: true,
                    suppressScrollWhenPopupsAreOpen: true,
                    enableCellTextSelection: true,
                    onCellValueChanged: handleCellValueChanged,
                    onGridReady: onGridReady
                  }}
                  containerStyle={{
                    height: "100%",
                  }}
                />
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "10px",
                padding: "12px",
              }}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled={!isAddButtonEnabled}
                onClick={handleAddClick}>
                {t("LBL_DONE")}
              </Button>

              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={handleCancelClick}>
                {t("CANCEL")}
              </Button>
            </Box>
          </div>
          <div></div>
        </Split>
      </Drawer>
    </>
  );
}

export default CustomHeaderFieldsModal;
